import React from 'react'
import Grid from '@mui/material/Unstable_Grid2'
import { ColumnsLayoutComponent } from './Columns.type'
import AlertBanner from '../../AlertBanner'
import TextComponent from '../../Text'
import CardComponent from '../../Card'
import TabModule from '../../TabModule/TabModule'
import CallToAction from '../../CallToAction'
import HelpImage from '../../Image/Variants/HelpImage'
import Form from '../../Form'
import CodeModule from '../../CodeModule'
import HelpPageList from '../../List/Variants/HelpPageList'
import { ContentfulToComponent } from '../../RichText/types'
import { useTheme } from '@mui/material/styles'

const ColumnsLayout: React.FC<ColumnsLayoutComponent> = ({
  numberOfColumns,
  columnContent,
  backgroundStyles,
  ratioOfColumnWidth,
  alignContent,
  space,
}: ColumnsLayoutComponent) => {
  const { palette } = useTheme()
  const styles = {
    container: {
      marginBottom: '1rem',
      color: backgroundStyles?.color ?? '',
      border: backgroundStyles?.borderColor ? `1px solid ${backgroundStyles?.borderColor}` : '',
      backgroundColor: backgroundStyles?.backgroundColor ?? palette.common.white,
      borderRadius: backgroundStyles ? '6px' : '',
    },
  }
  // Calculate the width for each grid item based on the ratio If null equal width for all columns
  // If columns are null for some reason, default column to 1
  const ratioArray = ratioOfColumnWidth ? ratioOfColumnWidth.split(':') : []
  const sumOfRatio = ratioArray.length > 0 ? ratioArray.reduce((acc, curr) => acc + parseInt(curr), 0) : 1
  const spacing = space?.includes('large') ? 7 : 3
  const itemWidth = 12 / (numberOfColumns ?? 1)
  const columnComponentMap: Partial<ContentfulToComponent> = {
    'HelpUniverseComponentAlert': AlertBanner,
    'HelpUniverseComponentTabs': TabModule,
    'HelpUniverseComponentText': TextComponent,
    'HelpUniverseComponentCard': CardComponent,
    'HelpUniverseComponentImage': HelpImage,
    'HelpUniverseComponentList': HelpPageList,
    'HelpUniverseModuleForm': Form,
    'HelpUniverseModuleDynamicComponents': CodeModule,
    'HelpUniverseLayoutColumns': ColumnsLayout,
    'HelpUniverseComponentCta': CallToAction,
  } as const
  return (
    <>
      <Grid sx={styles.container} container spacing={spacing} alignItems={alignContent ?? 'center'}>
        {columnContent?.map((item: any, index) => {
          if (!item?.internal?.type) return
          const Component: any = columnComponentMap[item.internal.type as keyof typeof columnComponentMap]
          const itemWidthRatio =
            ratioArray.length > 0 ? (12 * parseInt(ratioArray[index % numberOfColumns])) / (sumOfRatio ?? 1) : itemWidth
          return (
            <Grid key={index} xs={12} md={itemWidthRatio}>
              <Component {...item} />
            </Grid>
          )
        })}
      </Grid>
    </>
  )
}

export default ColumnsLayout
